import { fromHouseConsignmentDetailsResponse, toUpdateHouseConsignmentRequest } from '../models/mapper'
import { HouseConsignmentUpdate } from '../models/request'
import { HouseConsignmentDetails } from '../models/types'
import { updateHouseConsignmentV3 } from './http'

// eslint-disable-next-line import/prefer-default-export
export async function updateHouseConsignment(id: number, data: HouseConsignmentUpdate): Promise<HouseConsignmentDetails> {
  const response = await updateHouseConsignmentV3(id, toUpdateHouseConsignmentRequest(data))
  return fromHouseConsignmentDetailsResponse(response)
}
